import { render, staticRenderFns } from "./PanelCourseList.vue?vue&type=template&id=b77d40d8&scoped=true"
import script from "./PanelCourseList.vue?vue&type=script&lang=js"
export * from "./PanelCourseList.vue?vue&type=script&lang=js"
import style0 from "./PanelCourseList.vue?vue&type=style&index=0&id=b77d40d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77d40d8",
  null
  
)

export default component.exports